import { useEffect, useState } from "react";
import { isEmpty } from "lodash-es";
import z from "zod";

type UseSetErrorMessageProps = {
  /** The error message to set. */
  error?: Record<string, string[]>;
};

/**
 * Hook to set the error message for an input.
 */
const useSetErrorMessage = ({ error = {} }: UseSetErrorMessageProps) => {
  const [fieldsErrors, setFieldsErrors] = useState<Record<string, string>>({});

  useEffect(() => {
    if (isEmpty(error)) return;
    const errors = Object.fromEntries(
      Object.entries(error).map(([key, value]) => [key, value[0]])
    );

    setFieldsErrors(errors);
  }, [error]);

  const handleSetDataError = (
    fieldName: string,
    schema: z.ZodSchema,
    value: unknown
  ) => {
    if (!schema) return;

    const validatedFields = schema.safeParse(value);

    if (!validatedFields.success) {
      setFieldsErrors((prev) => ({
        ...prev,
        [fieldName]: validatedFields.error.issues[0].message,
      }));

      return;
    }

    setFieldsErrors((prev) => ({
      ...prev,
      [fieldName]: "",
    }));
  };

  return {
    fieldsErrors,
    handleSetDataError,
  };
};

export default useSetErrorMessage;
